var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDwnldbtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    transform: "translate(-1186 -101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 24,
    height: 24,
    transform: "translate(1186 101)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    d: "M-6524.285,15317.508a.713.713,0,0,1-.619-.357.714.714,0,0,1,0-.714.713.713,0,0,1,.619-.357h15.719a.713.713,0,0,1,.619.357.714.714,0,0,1,0,.714.713.713,0,0,1-.619.357Zm7.354-4.161-4.1-4.1a.716.716,0,0,1-.175-.687.717.717,0,0,1,.5-.5.717.717,0,0,1,.686.176h0l2.878,2.877v-10.4a.715.715,0,0,1,.209-.506.716.716,0,0,1,.505-.209.716.716,0,0,1,.505.209.715.715,0,0,1,.209.506v10.4l2.877-2.877a.71.71,0,0,1,.508-.218.712.712,0,0,1,.511.209.714.714,0,0,1,.209.512.716.716,0,0,1-.218.508l-4.1,4.1a.714.714,0,0,1-.5.209A.716.716,0,0,1-6516.931,15313.347Zm.505-13.344Z",
    transform: "translate(7714.426 -15196.002)",
    fill: "#f17456"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwnldbtn);
export default __webpack_public_path__ + "static/media/dwnldbtn.eb94899466dea141a76207ee1ee5a034.svg";
export { ForwardRef as ReactComponent };